import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLoggedIn } from 'data_system/token_auth/selectors';

export const ROOT = '/';
export const LOGIN = '/login';
export const SIGNUP_REQUEST = '/signup_request';
export const SIGNUP = '/signup';
export const RESET_PASSWORD_REQUEST = '/reset_password_request';
export const RESET_PASSWORD = '/reset_password';
export const PORTAL_DISABLED = '/portal_disabled';

// A <Route> that redirects to the home screen if you're already authenticated
export const UnauthenticatedRoute = ({ children, ...rest }) => {
  const loggedIn = useSelector(getLoggedIn);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        !loggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: ROOT,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

// A <Route> that redirects to the login screen if you're not yet authenticated.
export const ProtectedRoute = ({ children, ...rest }) => {
  const loggedIn = useSelector(getLoggedIn);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        loggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: LOGIN,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export const Protected = ({ children }) => {
  const loggedIn = useSelector(getLoggedIn);

  return loggedIn ? children : null;
};
